import { render, staticRenderFns } from "./Star.vue?vue&type=template&id=0688cc78&scoped=true&"
import script from "./Star.vue?vue&type=script&lang=js&"
export * from "./Star.vue?vue&type=script&lang=js&"
import style0 from "./Star.vue?vue&type=style&index=0&id=0688cc78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0688cc78",
  null
  
)

export default component.exports